<template>
  <div class="el-Require">
    <el-row class="page_content">
      <h1 class="head_title">上传终稿</h1>
      <div v-loading="loading">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="replyform">
          <el-form-item label="论文题名" prop="choiceThesisTitle">
            <el-input v-model="form.choiceThesisTitle" placeholder="请输入论文题名"></el-input>
          </el-form-item>
          <el-form-item label="选题描述" prop="choiceThesisTitleDescription">
            <el-input type="textarea" v-model="form.choiceThesisTitleDescription"
              placeholder="请输入选题描述"></el-input>
          </el-form-item>
          <el-form-item label="上传终稿" required>
            <el-upload class="final-uploader" :action="uploadUrl" :headers="headers"
              :show-file-list="false" :on-success="handleUploadSuccess">
              <el-button size="small" type="primary">点击上传</el-button>
              <span class="file_name" v-if="form.finalFileUrl">
                {{ form.finalFileName || form.finalFileUrl }}
              </span>
              <span class="file_tip" v-else>暂未上传文件</span>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 80px;" @click="save" :loading="submitLoading">提 交</el-button>
            <!-- <span style="color: #909399; margin-left: 10px;">可重复提交</span> -->
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getCookieForRoleTag } from '../../common/ulit'
export default {
  name: "finalUpload",
  data() {
    return {
      loading: false,
      submitLoading: false,
      uploadUrl: this.$baseUrl + "/api/file/update.do", //文件上传接口
      headers: {
        token: getCookieForRoleTag(),
        "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null
      },
      form: {
        choiceThesisTitle: '',
        choiceThesisTitleDescription: '',
        finalFileUrl: '',
        finalFileName: ''
      },
      rules: {
        choiceThesisTitle: [
          { required: true, message: "请输入论文题名", trigger: "blur" }
        ],
        choiceThesisTitleDescription: [
          { required: true, message: "请输入选题描述", trigger: "blur" }
        ]
      }
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    // 反显：查询学生论文信息
    getDetail() {
      this.loading = true;
      let param = {};
      this.$store.dispatch("thesis/getThesisCheckDetailByParam", param).then((ret) => {
        this.loading = false;
        if (ret.code == 0) {
          let thesisRecord = ret.data.thesisRecord || {};
          this.form.choiceThesisTitle = thesisRecord.choiceThesisTitle || '';
          this.form.choiceThesisTitleDescription = thesisRecord.choiceThesisTitleDescription || '';
          this.form.finalFileUrl = thesisRecord.finalFileUrl || '';
          this.form.finalFileName = thesisRecord.finalFileName || '';
        } else {
          this.$message.error(ret.msg);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 上传终稿成功回调（暂不限制上传类型）
    handleUploadSuccess(res) {
      if (res.code == 0) {
        this.form.finalFileName = res.data.title;
        this.form.finalFileUrl = res.data.url;
        this.$message.success("终稿上传成功");
      } else {
        this.$message.error(res.msg || "文件上传失败");
      }
    },
    // 提交
    save() {
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (!this.form.finalFileUrl) {
          this.$message.warning("请先上传终稿");
          return false;
        }
        let param = {
          choiceThesisTitle: this.form.choiceThesisTitle,
          choiceThesisTitleDescription: this.form.choiceThesisTitleDescription,
          finalFileUrl: this.form.finalFileUrl
        };
        this.submitLoading = true;
        this.$store.dispatch("thesis/directlySubmitFinalUrl", param).then((ret) => {
          this.submitLoading = false;
          if (ret.code == 0) {
            this.$message({
              showClose: true,
              message: '终稿提交成功',
              type: 'success'
            });
            this.getDetail(); //提交后刷新反显与审核记录
          } else {
            this.$message.error(ret.msg);
          }
        }).catch(() => {
          this.submitLoading = false;
        });
      });
    }
  }
}
</script>
<style lang="less" scoped>
.replyform {
  width: 868px;
  margin: 0 auto;
}
.final-uploader {
  display: inline-flex;
  align-items: center;
  .file_name {
    margin-left: 10px;
    color: #303133;
  }
  .file_tip {
    margin-left: 10px;
    color: #c0c4cc;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/transactionPaper/finalUpload.vue